<script setup lang="ts">
import { useRouter } from 'vue-router';
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { TrackEventCategory } from '@/application/utils/tracking/events';

defineProps<{
  bankAccessId: string,
  depotId: string,
}>();

const router = useRouter();

async function onOpenInvestment(e: CustomEvent) {
  useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'openInvestment' });
  const { bankAccessId, depotId, investmentId } = e.detail;
  await router.push(`/banking/${bankAccessId}/depot/${depotId}/investment/${investmentId}`);
}
</script>

<template>
  <BankingWrapper v-slot="{ token, onEmitError }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <!-- eslint-disable vue/attribute-hyphenation -->
    <ba-depot-detail
      :token="token"
      :bankAccessId="bankAccessId"
      :depotId="depotId"
      @openInvestment="onOpenInvestment"
      @emitError="(e) => onEmitError(e, 'ba-depot-detail')"
    />
  </BankingWrapper>
</template>
